// extracted by mini-css-extract-plugin
module.exports = {"container":"issueTile_container__3dPmG","dealListPanelGroupItem":"issueTile_dealListPanelGroupItem__sj6IF"};